import {request, serviceUrl} from "@/utils/request";

//获取组织树
export function getOrgList() {
    return request({
        url: serviceUrl.iamService + "/organization/orgTree"
    })
}